export default __webpack_public_path__ + "static/walsh-713a429b475c8b8c9a5334e53b416ee3.jpg";